export default function realFormatter(real: number) { 
    return real.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

